import React from 'react';
import { Link } from 'gatsby';
const Footer = (props) => (
	<footer id="footer">
		{/* <section>
			<h2>Questions!</h2>
			<dl className="alt">
				<dt>Email</dt>
				<dd>cmb3416@gmail.com</dd>
				<dt>Phone</dt>
				<dd>(480) 560-6084</dd>
			</dl>
        </section> */}
		{/* <h4>Questions!</h4> */}
		<p className="copyright">cmb3416@gmail.com &bull; (480) 560-6084 &bull; 1221 E Apache Blvd Apt. 4094 Tempe AZ 85281</p>
	</footer>
);

export default Footer;
